var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SmartColumnLayout",style:({ 'grid-template-columns': 'repeat(' + _vm.columns + ', 1fr)' })},_vm._l((_vm.columns),function(index){return _c('div',{key:index,ref:"columns",refInFor:true,staticClass:"SmartColumnLayout__column"},[_vm._t("item")],2)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a3dbee8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Help/SmartColumnLayout/index.vue
// module id = 1234
// module chunks = 0 1